var map = {
	"./account.ts": "./src/router/modules/account.ts",
	"./authentication.ts": "./src/router/modules/authentication.ts",
	"./errors.ts": "./src/router/modules/errors.ts",
	"./files.ts": "./src/router/modules/files.ts",
	"./preview.ts": "./src/router/modules/preview.ts",
	"./roles.ts": "./src/router/modules/roles.ts",
	"./static-pages.ts": "./src/router/modules/static-pages.ts",
	"./users.ts": "./src/router/modules/users.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/router/modules sync recursive [A-Za-z0-9-_,\\s]+\\.ts$/";